<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 48 48" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <g data-follow-fill="currentColor" :fill="_fill">
        <path d="M38.3 37.8H9.7C5.4 37.8 2 40.6 2 44c0 1.1 1.2 2 2.6 2h38.9c1.4 0 2.6-.9 2.6-2-.1-3.4-3.5-6.2-7.8-6.2zM45 13.1c-.7-1.1-1.7-1.9-2.9-2.6l-8.5-4.7c-2.1-1.2-3.8-2.1-5.3-2.8-1.5-.7-2.9-1-4.4-1s-2.9.4-4.4 1c-1.5.6-3.2 1.6-5.3 2.8l-8.5 4.7c-1.1.7-2 1.5-2.7 2.6-.7 1.1-1 2.4-1 3.8v.1c0 .5 0 1 .1 1.5.3 1.1 1 1.9 2 2.4.8.4 1.7.4 2.4.4h34.9c.7 0 1.6 0 2.4-.4.9-.4 1.7-1.2 2-2.4.1-.5.1-1 .1-1.5.1-1.5-.2-2.7-.9-3.9zM24 18c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z" />
        <path d="M7 20.5h8v18H7zm26 0h8v18h-8zM20 21h8v18h-8z" />
      </g>
    </g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
